import type { ButtonHTMLAttributes, ReactNode } from "react";

// Button — codified 1:1 from 07-dugmeler.html. Six type variants (primary/approve/
// secondary/soft/ghost/danger + the solid-danger used in destructive dialogs), three
// sizes, and the loading (inline spinner) + disabled states. Copy is the caller's
// (children); no business logic. `loading` swaps in the spinner and blocks the click.
export type ButtonVariant =
  | "primary"
  | "approve"
  | "secondary"
  | "soft"
  | "ghost"
  | "danger"
  | "danger-solid";

export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  /** Optional leading glyph (e.g. an <Icon/>), rendered before the label. */
  leadingIcon?: ReactNode;
}

export function Button({
  variant = "secondary",
  size = "md",
  loading = false,
  leadingIcon,
  className,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const classes = [
    "k-btn",
    `k-btn--${variant}`,
    size !== "md" ? `k-btn--${size}` : "",
    loading ? "k-btn--loading" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classes} disabled={disabled || loading} aria-busy={loading} {...props}>
      {loading ? <span className="k-spinner" aria-hidden="true" /> : leadingIcon}
      {children}
    </button>
  );
}
